'use strict';

angular.module('boxTemplateModule', []);